<template>
<div id="index">
  <div id="ads">
    <el-link @click="toPage('/conact')" :underline="false">
      <img width="80%" src="../assets/img/joinus.png" alt="">
    </el-link>
  </div>
  <el-carousel indicator-position="none" height="380px" >
    <el-carousel-item
        v-for="item in imgLists"
        :key="item.url"
    >
      <img class="carousel-img" height="380px" :src="item.url" />
    </el-carousel-item>
  </el-carousel>
  <div class="boxItem">
    <div class="subTitle">
      <span style="font-weight: bolder">团队介绍</span>
      <el-link @click="toPage('/team/introduction')" :underline="false" class="el-icon-more" style="color: white"></el-link>
    </div>
    <el-row :gutter="20" style="height: 200px;">
      <el-col :span="14">
        <div class="teamPerson">
          <div style="display: inline-block; position: relative" v-for="photo in photoLists" :key="photo.url">
            <el-image
                class="personCard"
                :src="photo.url"
                fit="fill">
            </el-image>
            <div class="personInfo">
              <span style="font-weight: bold">{{photo.name}}</span> <br/>
              <span style="font-weight: bold">{{photo.synopsis}}</span>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="10">
        <span class="introInfo">
          武汉大学测绘遥感信息工程国家重点实验室实时智能遥感研究团队是由武汉大学二级教授、博士生导师眭海刚教授为学术带头人，3位正教授、4位副教授和多名科研助理及博硕士研究生组成的团队，主要研究实时摄影测量、遥感影像自动解译、时空大数据、多维GIS、空中飞行器、多传感器集成、无人系统集群等，科研成果已服务国家应急、测绘地理、国家林草、公共安全等多个领域成果应用，发表SCI、EI等300多篇学术论文，编写专著8部，软件著作权40项，授权发明专利80项，获国家科技进步一等奖1项、国家科技进步二等奖3项，测绘科技进步一等奖4项，教育部技术发明一等奖奖1项，教育部科技进步一等奖1项，军队科技进步奖2项。培养的学生多次获国内外大赛奖，毕业生分布在国内外高校、大型企事业单位等。团队拥有星载/机载处理硬件、多架无人机、大型私有云计算平台等硬件条件和多个遥感专业化系统与软件平台保障，一直站在国际最前沿和国家重大需求第一线。
        </span>
      </el-col>
    </el-row>
  </div>
<!--  ==================  -->
  <el-row >
    <el-col :span="24">
      <div class="boxItem">
        <div class="subTitle">
          <span style="font-weight: bolder" >最新消息</span>
<!--          <el-link @click="toPage('/projects')" :underline="false" class="el-icon-more" style="color: white"></el-link>-->
        </div>
        <ul>
          <li v-for="item in news" :key="item.id">
            <div class="newsTitle">
              <i class="el-icon-news" style="padding-right: 15px"></i>
              <el-link :href="item.src" :underline="false" target="_blank" >{{item.title}}</el-link>
            </div>
            <span class="newsDate">{{item.date}}</span>
          </li>
        </ul>
      </div>
    </el-col>
<!--    <el-col :span="12">-->
<!--      <div class="boxItem">-->
<!--        <div class="subTitle">-->
<!--          <span style="font-weight: bolder" >科研项目</span>-->
<!--          <el-link @click="toPage('/projects')" :underline="false" class="el-icon-more" style="color: white"></el-link>-->
<!--        </div>-->
<!--        <ul>-->
<!--          <li v-for="item in projects" :key="item.id">-->
<!--            <i class="el-icon-star-off"></i>-->
<!--            <span class="newsTitle">{{item.title}}</span>-->
<!--            <span class="newsDate">{{item.date}}</span>-->
<!--          </li>-->
<!--        </ul>-->
<!--      </div>-->
<!--    </el-col>-->
  </el-row>

  <div class="boxItem">
    <div class="subTitle">
      <span style="font-weight: bolder">科研成果</span>
      <el-link @click="toPage('/academic/book')" :underline="false" class="el-icon-more" style="color: white"></el-link>
    </div>
    <el-row :gutter="10">
      <el-col :span="12">
        <div class="subtitle3">
          <i class="el-icon-s-management"></i>
          专题著作
        </div>
        <ul>
          <li @click="toPage('/academic/book')" v-for="item in works" :key="item.id">
            <i class="el-icon-star-off"></i>
            <span class="newsTitle">{{item.title}}</span>
            <span class="newsDate">{{item.press}}</span>
          </li>
        </ul>
      </el-col>
      <el-col :span="12">
        <div class="subtitle3">
          <i class="el-icon-document"></i>
          学术论文
        </div>
        <ul>
          <li @click="toPage('/academic/paper')" v-for="item in papers" :key="item.id">
            <i class="el-icon-star-off"></i>
            <span class="newsTitle">{{item.title}}</span>
            <span class="newsDate">{{item.date}}</span>
          </li>
        </ul>
      </el-col>
    </el-row>
  </div>
  <div class="boxItem">
    <div class="subTitle">
      <span style="font-weight: bolder">成果奖励</span>
      <el-link @click="toPage('/academic/book')" :underline="false" class="el-icon-more" style="color: white"></el-link>
    </div>
    <swiper class="swiper" :options="swiperOption">
      <swiper-slide @mouseleave.native="loopSwiper" @mouseenter.native="stopLoop" v-for="(item, index) in awards" :key="index">
        <img width="100%" height="100%" :src="item.url" alt="">
      </swiper-slide>
      <!-- <div class="swiper-pagination" slot="pagination"></div> -->
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" ref="nextRef" slot="button-next"></div>
    </swiper>
  </div>
</div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
name: "Index",
components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      swiperOption: {
          slidesPerView: 5,
          spaceBetween: 30,
          slidesPerGroup: 1,
          loop: true,
          loopFillGroupWithBlank: true,
          // pagination: {
          //   el: '.swiper-pagination',
          //   clickable: true
          // },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        },
      imgLists: [
        {url: require("../assets/img/carousel/carousel-6.png")},
        {url: require("../assets/img/carousel/carousel-1.jpg")},
        // {url: require("../assets/img/carousel/carousel-2.jpg")},
        {url: require("../assets/img/carousel/carousel-3.jpg")},
        // {url: require("../assets/img/carousel/carousel-4.jpg")},
        {url: require("../assets/img/carousel/carousel-51.jpg")},
      ],
      photoLists: [
        {
          name: "眭海刚教授",
          url: require("../assets/img/people/shg.jpg"),
          synopsis:
            "二级教授，博导"
        },
        {
          name: "马国锐教授",
          url: require("../assets/img/people/马国锐教授.png"),
          synopsis: "研究员，博导",
          // 主要研究方向为遥感影像目标检测识别、语义分割提取、灾害/损毁评估、大数据预测预警等。
        },
        {
          name: "孙开敏教授",
          url: require("../assets/img/people/孙开敏教授.jpg"),
          synopsis: "教授，博导",
          // 主要研究方向为多源遥感影像变化检测、智能解译、时序分析以及无人机应用等。
        },
        {
          name: "肖志峰教授",
          url: require("../assets/img/people/肖志峰副教授.png"),
          synopsis: "教授，博导",
          // 主要研究方向为计算机视觉、人工智能、大数据分析挖掘及在遥感应用等。
        }
      ],
      news: [
        {
          id: 6,
          title: "热烈祝贺李德仁院士荣获国家最高科学技术奖！！",
          date: "2024/6/24",
          src: "https://mp.weixin.qq.com/s/J2ifWagYNEfAsFhRvaB6RA"
        },
        {
          id: 0,
          title: "实验室眭海刚教授在遥感应急领域再次获批国家重点研发计划项目",
          date: "2025/1/2",
          src: "https://mp.weixin.qq.com/s/07hm83NXHT6e06MSeUw7HQ"
        },
        {
          id: 1,
          title: "武汉大学与国家林业和草原局签署战略合作协议",
          date: "2024/11/19",
          src: "https://mp.weixin.qq.com/s/_83QCac1sxSVNsQaFCVAiA"
        },
        {
          id: 2,
          title: "眭海刚教授课题组多源卫星影像洪灾监测成果发表在遥感顶刊",
          date: "2024/10/30",
          src: "https://mp.weixin.qq.com/s/k-UUQJ8HLPoRKMhIxW52zw"
        },
        {
          id: 3,
          title: "【教与学的革命】眭海刚教授带领华师附中学生感受空天遥感助力应急监测",
          date: "2024/5/11",
          src: "https://mp.weixin.qq.com/s/AzLhp-xcvFKvI8vuzi0Cmg"
        },
        {
          id: 4,
          title: "实时遥感团队在2023”智在飞翔“无人机大赛中夺冠！",
          date: "2023/12/26",
          src: "https://mp.weixin.qq.com/s/DY5UQT_qAzx_dId8y2UFZA"
        },
        {
          id: 5,
          title: "【科研成果速递】面向高分辨率场景三维重建的多无人机协同且连续的路径规划",
          date: "2023/9/4",
          src: "https://mp.weixin.qq.com/s/vPuvze059QQR-_PUpZRfpQ"
        }
      ],
      projects: [
        {
          id: 0,
          title: "国家重点研发计划，区域协同遥感监测与应急服务技术体系",
          date: "2016-2020",
          src: "#"
        },
        {
          id: 1,
          title: "国家自然科学基金，空地一体遥感震灾建筑物多级损毁自动判定研究",
          date: "2018-2021",
          src: "#"
        },
        {
          id: 2,
          title: "GF重大研制项目，SPD改进研制",
          date: "2016-2018",
          src: "#"
        },
        {
          id: 3,
          title: "GF重大型号项目，SPD采购项目",
          date: "2016-2018",
          src: "#"
        },
        {
          id: 4,
          title: "高分专项，XX灾害监测预评估与可视化技术研究及应用示范",
          date: "2013-2015",
          src: "#"
        },
        {
          id: 5,
          title: "国家主题863项目，统一时空体系下的多源信息实时接入与异构信息自主加载技术",
          date: "2013-2015",
          src: "#"
        }
      ],
      works: [
        {
          id: 0,
          title: "高分辨率遥感影像灾害目标损毁信息提取技术",
          press: "武汉大学出版社",
          author: "",
          src: "#"
        },
        {
          id: 1,
          title: "空天地大数据公共安全事件预测建模技术",
          press: "科技出版社",
          author: "",
          src: "#"
        },
        {
          id: 2,
          title: "基于特征的光学与SAR遥感图像配准",
          press: "科学出版社",
          author: "",
          src: "#"
        },
        {
          id: 3,
          title: "面向任务的遥感信息聚焦服务",
          press: "科学出版社",
          author: "",
          src: "#"
        },
        {
          id: 4,
          title: "Processing of multitemporal data and change detection. Advances in Photogrammetry",
          press: "ISPRS.Congress",
          author: "",
          src: "#"
        },
        {
          id: 5,
          title: "遥感变化检测新技术",
          press: "西安地图出版社",
          author: "",
          src: "#"
        }
      ],
      papers: [
        {
          id: 0,
          title: "MCTracker: Satellite video multi-object tracking considering inter-frame motion correlation and multi-scale cascaded feature enhancement",
          author: "",
          src: "https://doi.org/10.1016/j.isprsjprs.2024.06.006",
          date: "2024"
        },
        {
          id: 1,
          title: "Vectorized building extraction from high-resolution remote sensing images using spatial cognitive graph convolution model",
          author: "",
          src: "https://doi.org/10.1016/j.isprsjprs.2024.05.015",
          date: "2024"
        },
        {
          id: 2,
          title: "Flood inundation monitoring using multi-source satellite imagery: a knowledge transfer strategy for heterogeneous image change detection",
          author: "",
          src: "https://www.sciencedirect.com/science/article/pii/S0034425724003997",
          date: "2024"
        },
        {
          id: 3,
          title: "Refined Landslide Susceptibility Mapping Considering Land Use Changes and InSAR Deformation: A Case Study of Yulin City, Guangxi",
          author: "",
          src: "https://www.proquest.com/scholarly-journals/refined-landslide-susceptibility-mapping/docview/3098195883/se-2?accountid=15157",
          date: "2024"
        },
        {
          id: 4,
          title: "Mapping national-scale photovoltaic power stations using a novel enhanced photovoltaic index and evaluating carbon reduction benefits",
          author: "",
          src: "https://doi.org/10.1016/j.enconman.2024.118894",
          date: "2024"
        },
        {
          id: 5,
          title: "Few-Shot Object Detection in Remote Sensing Imagery via Fuse Context Dependencies and Global Features",
          author: "",
          src: "https://doi.org/10.3390/rs15143462",
          date: "2023"
        }
      ],
      awards: [
        {
          name: "2019-领导干部自然资源资产离任审计测绘地理信息关键技术研究与应用-测绘科技进步奖二等奖眭海刚",
          url:require("../assets/img/awards/award (1).jpg")
        },
        {
          name: "2019遥感影像装备眭海刚",
          url:require("../assets/img/awards/award (2).jpg")
        },
        {
          name: "201809测绘科技进步一等奖-基础地理信息动态更新与变化检测眭海刚",
          url:require("../assets/img/awards/award (3).jpg")
        },
        {
          name: "201812湖北省测绘科技进步一等奖-智慧老河口时空信息云平台建设试点眭海刚",
          url:require("../assets/img/awards/award (4).jpg")
        },
        {
          name: "201901遥感技术及装备",
          url:require("../assets/img/awards/award (5).jpg")
        },
        {
          name: "201910领导干部自然资源资产离任审计测绘地理信息关键技术研究与应用",
          url:require("../assets/img/awards/award (6).jpg")
        },
        {
          name: "20181205遥感影像典型地理要素更新系统",
          url:require("../assets/img/awards/award (7).jpg")
        },
        {
          name: "20191118空天遥感数据一体化准实时处理系统",
          url:require("../assets/img/awards/award (8).jpg")
        },
        {
          name: "20200310一种基于自适应聚类学习的道路网提取的方法",
          url:require("../assets/img/awards/award (9).jpg")
        },
        {
          name: "20200424基于随机森林的多尺度分层采样的高分卫星影像变化检测方法",
          url:require("../assets/img/awards/award (10).jpg")
        },
        {
          name: "20200505导航数据辅助下的遥感影像道路网提取方法",
          url:require("../assets/img/awards/award (11).jpg")
        },
        {
          name: "20200922一种软硬件一体的便携式遥感影像实时处理系统",
          url:require("../assets/img/awards/award (12).jpg")
        },
        {
          name: "20201201静止轨道卫星序列遥感影像海岛礁区域自动几何校正方法",
          url:require("../assets/img/awards/award (13).jpg")
        }
      ],
      timer: null
    }
  },

  mounted() {
    this.loopSwiper()
  },
  methods: {
    toPage(path){
      // this.$router.push(path)
      console.log(path)
      this.$parent.saveNavState(path);
    },
    loopSwiper(){
      const that = this
      this.timer = setInterval(function(){
        console.log("124")
        that.$refs.nextRef.click();
      }, 3000)
    },
    stopLoop(){
      clearInterval(this.timer)
    }
  }
}
</script>

<style lang="less" scoped>
#index{
  //position: relative;
  #ads {
    position: fixed;
    top: 200px;
    right: 200px;
  }
  .el-carousel{
    margin: 5px 0;
    box-shadow: 0 0 3px #4f4f4f;
    padding: 0 2px;
    border-radius: 2px;
  }
  .boxItem:hover{
    box-shadow: 0 0 5px #4f4f4f;
  }
  .boxItem{
    background-color: white;
    box-shadow: 0 0 2px #4f4f4f;
    border-radius: 2px;
    margin: 10px 0;
    .subTitle{
      background: linear-gradient(90deg, #076498 0%, #69CDFE 100%);
      padding: 10px;
      color: white;
      display: flex;
      justify-content: space-between;
      border-radius: 2px;
    }
    .introInfo{
      display: block;
      text-indent: 36px;
      text-align: justify;
      line-height: 26px;
      padding: 15px 15px 0 0;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 6;
      overflow: hidden;
      font-size: 14px;
      color: #454545;
    }
    .teamPerson{
      margin-top: 10px;
      padding: 5px;
      height: 160px;
      display: flex;
      justify-content: space-between;
      .personCard{
        width: 120px;
        margin:0 8px;
      }
      .personInfo{
        font-size: 14px;
        text-align: center;
        color: white;
        display: inline-block;
        width: 120px;
        height: 20px;
        background-color: rgba(7, 100, 152, 0.7);
        position: absolute;
        left: 8px;
        bottom: 5px;
        overflow: hidden;
      }
      .personInfo:hover{
        height: 40px;
      }
      .prev, .next{
        display: inline;
        height: 100%;
        width: 20px;
        background-color: rgba(7, 100, 152, 0.2);
      }
      .el-icon-arrow-left, .el-icon-arrow-right {
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;
      }
      .prev:hover, .next:hover{
        cursor: pointer;
      }
      .el-icon-arrow-left, .el-icon-arrow-right{
        margin: 72px auto;
        color: #076498;
        font-weight: bolder;
      }
    }
    .subtitle3 {
      padding: 10px 10px 0 10px;
      color: #076498;
      font-weight: bold;
    }
    ul {
      padding: 0;
      padding-bottom: 8px;
      li{
        padding: 0 10px;
        margin: 10px 0;
        list-style: none;
        display: flex;
        justify-content: space-between;
        line-height: 22px;
        font-size: 14px;
        color: #454545;
        i {
          color: #076498;
        }
        .newsTitle{
          width: 60%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .newsDate{
          font-size: 12px;
          min-width: 100px;
          padding-left: 30px;
          color: #9b9b9b;
        }
      }
      li:hover{
        color: #076498;
        cursor: pointer;
      }
    }

    .swiper {
      height: 200px;
      padding: 10px 0;
      width: 100%;

      .swiper-slide {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        font-weight: bold;
        // font-size: $font-size-huge * 2;
        // background-color: $white;
      }
    }
  }
  .introduce{
    overflow: hidden;

  }

}
</style>
